import { motion } from "framer-motion";

const CHAPTERS = [
  {
    no: "01",
    title: "Ustalık",
    text: "Her parça, atölyemizde yılların deneyimine sahip ustaların elinden çıkar. Makine değil, sabır ve birikim şekillendirir ahşabı.",
  },
  {
    no: "02",
    title: "Malzeme",
    text: "Meşe, ceviz ve kayın; yalnızca sürdürülebilir ormanlardan. Doğal yağlarla biten yüzeyler, ahşabın nefes almasına izin verir.",
  },
  {
    no: "03",
    title: "Tasarım",
    text: "Trendleri değil, zamanı takip ederiz. Yirmi yıl sonra da bugünkü kadar iyi görünecek formlar peşindeyiz.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="bg-[#1C1B1A] text-stone-100 py-24 md:py-40" data-testid="manifesto-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-20"
      >
        Manifesto
      </motion.p>
      <div className="flex flex-col gap-24 md:gap-32">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.no}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start ${
              i % 2 === 1 ? "md:text-right" : ""
            }`}
            data-testid={`manifesto-chapter-${c.no}`}
          >
            <span className={`font-serif italic text-6xl md:text-8xl text-wood-light/60 leading-none md:col-span-3 ${i % 2 === 1 ? "md:order-3" : ""}`}>
              {c.no}
            </span>
            <h3 className={`font-serif font-light text-4xl md:text-6xl tracking-tight md:col-span-4 ${i % 2 === 1 ? "md:order-2" : ""}`}>
              {c.title}
            </h3>
            <p className={`text-stone-400 font-light leading-relaxed text-base md:text-lg max-w-md md:col-span-5 ${i % 2 === 1 ? "md:order-1 md:justify-self-end" : ""}`}>
              {c.text}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
